<template>
  <div>
    <v-row>
      <v-col cols="2">
        <v-autocomplete
          v-model="section.property"
          :items="properties"
          :item-text="'name'"
          :item-value="'name'"
          return-object
          placeholder="Select property"
          outlined
          dense
          @change="selectedProperty(section.property)"
          clearable
          :rules="myRules"
          chips
          small-chips
          deletable-chips
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="section.condition"
          :items="filteredConditions"
          :item-text="'name'"
          :item-value="'value'"
          placeholder="Select condition"
          outlined
          dense
          clearable
          :rules="myRules"
          chips
          small-chips
          deletable-chips
        />
      </v-col>
      <v-col
        cols="3"
        v-if="showValueInput || showValueInputSelect || showValueTreeSelect"
      >
        <v-text-field
          v-if="showValueInput"
          v-model="section.value"
          :placeholder="placeholder"
          outlined
          dense
          :type="valueType"
          clearable
          :rules="myRules"
        >
        </v-text-field>
        <v-autocomplete
          v-if="showValueInputSelect"
          v-model="section.value"
          :placeholder="placeholder"
          outlined
          dense
          :type="valueType"
          clearable
          :rules="myRules"
          :items="itemsData"
          :item-text="itemText"
          :item-value="itemValue"
          :loading="loadingValues"
          :multiple="multiple"
          chips
          small-chips
          deletable-chips
        >
        </v-autocomplete>
        <TreeSelect
          v-if="showValueTreeSelect"
          v-model="section.value"
          style="padding-top: 0px; margin-top: 0px; width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :treeData="itemsData"
          :replaceFields="{
            children: 'children',
            title: 'name',
            key: 'id',
            value: 'id',
          }"
          placeholder="Category"
          label="Category"
          filled
          multiple
          tree-checkable
          :maxTagCount="5"
        >
        </TreeSelect>
      </v-col>
      <v-col v-model="section.id" cols="1" class="py-5">
        <v-icon color="red" @click="$emit('remove')">mdi-close-thick</v-icon>
      </v-col>
    </v-row>
    <v-divider class="mb-2"></v-divider>
  </div>
</template>

<script>
import { TreeSelect } from "ant-design-vue";

export default {
  name: "FilterRowWholeSales",
  components: {
    TreeSelect,
  },
  props: {
    section: Object,
    rules: Array,
  },
  data: function () {
    return {
      myFruits: this.fruits,
      myProperties: this.properties,
      myRules: this.rules,
      showValueInput: false,
      showValueInputSelect: false,
      showValueTreeSelect: false,
      conditions: [
        { name: "Contains", value: "contains" },
        { name: "In", value: "in" },
        { name: "Not in", value: "not-in" },
        { name: "Equals", value: "equals" },
        { name: "Does not equal", value: "does not equals" },
        { name: ">", value: ">" },
        { name: ">=", value: ">=" },
        { name: "<", value: "<" },
        { name: "<=", value: "<=" },
        { name: "Yes", value: "yes" },
        { name: "No", value: "no" },
      ],
      valueType: "",
      propertyType: "",
      properties: [
        { name: "Category", type: "Array" },
        { name: "Brand", type: "Array" },
        { name: "Season", type: "ArrayContains" },
      ],
      itemsData: [],
      itemText: "",
      itemValue: "",
      loadingValues: false,
      multiple: false,
      dropdownsData: "",
      placeholder: "",
    };
  },
  computed: {
    filteredConditions() {
      let filteredConditions = [];

      switch (this.propertyType) {
        case "Array":
          filteredConditions = this.conditions.filter(
            (item) => item.name == "In" || item.name == "Not in"
          );
          break;
        case "Number":
          filteredConditions = this.conditions.filter(
            (item) =>
              item.name == "Equals" ||
              item.name == "Does not equal" ||
              item.name == ">" ||
              item.name == ">=" ||
              item.name == "<" ||
              item.name == "<="
          );
          break;
        case "ArrayContains":
          filteredConditions = this.conditions.filter(
            (item) => item.name == "Contains"
          );
          break;
        case "Boolean":
          filteredConditions = this.conditions.filter(
            (item) => item.name == "Yes" || item.name == "No"
          );
          break;
        default:
          filteredConditions = this.conditions;
      }
      return filteredConditions;
    },
    inputFilled() {
      if (this.section.property != "") {
        return true;
      }
      if (this.section.condition != "") {
        return true;
      }
      if (this.section.value != "") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async selectedProperty(value) {
      this.showValueInput = false;
      this.showValueInputSelect = false;
      this.showValueTreeSelect = false;
      this.multiple = false;
      this.itemText = "name"
this.itemValue = "id"
      if (value) {
        switch (value.type) {
          case "String":
            this.propertyType = "String";
            this.valueType = "text";
            this.showValueInput = true;
            break;
          case "Array":
            this.propertyType = "Array";
            this.valueType = "text";
            this.showValueInput = true;
            break;
          case "ArrayContains":
            this.propertyType = "ArrayContains";
            this.valueType = "text";
            this.showValueInput = true;
            break;
          case "Number":
            this.propertyType = "Number";
            this.showValueInput = true;
            this.valueType = "number";
            break;
          case "Boolean":
            this.propertyType = "Boolean";
            this.showValueInput = false;
            this.valueType = "boolean";
            break;
          default:
            this.showValueInput = false;
        }

        switch (value.name) {
          case "Brand":
          this.showValueInput = false;
            this.showValueInputSelect = true;
            this.multiple = true;
            this.placeholder = "Select brand";
            await this.getDropdowns();
            this.itemsData = this.dropdownsData.brands;
            break;
          case "Season":
            this.showValueInput = false;
            this.showValueInputSelect = true;
            this.multiple = true;
            this.placeholder = "Select season";
            await this.getDropdowns();
            this.itemsData = this.dropdownsData.seasons;
            break;
          case "Category":
            this.showValueInput = false;
            this.showValueInputSelect = false;
            this.showValueTreeSelect = true;
            await this.getDropdowns();
            this.itemsData = this.dropdownsData.categories;
            break;
        }
      }
    },
    async getDropdowns() {
      if (this.dropdownsData === "") {
        try {
          const response = await this.$store.dispatch("getDropdownsWholeSales");
          this.dropdownsData = response.data;
          console.log("data", response);
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style scoped></style>
